import React from "react";
import PropTypes from "prop-types";
import RtrButton from "components/design-system/rtr-button";

class AddToBagButton extends React.Component {
  static propTypes = {
    buttonCopy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    dataHeapId: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
  };

  render() {
    return (
      <RtrButton
        fullWidth
        disabled={this.props.disabled}
        loading={this.props.loading}
        dataTestId="add-to-bag-button"
        dataHeapId={this.props.dataHeapId}
        className="mt-4">
        {this.props.buttonCopy}
      </RtrButton>
    );
  }
}

export default AddToBagButton;
